import { useTranslation } from 'react-i18next';
import React, {useState, useCallback, useEffect} from "react";
//import './TestComponent.css'
import { makeStyles } from '@mui/styles';
import { Grid, Paper, TextField, Box,Button} from '@mui/material';
import ExampleWrapper from "./InfiniteScroll";
import apiRequest from '../../functions/api';
import { useNavigate } from "react-router-dom";
import { useMessage } from "../../context/message-context";
import { SearchTextField } from "../lib";
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',  
    backgroundColor: theme.palette.background.paper,
  },
}));
function TestComponent(props) {
  const { t } = useTranslation();
  const [interview,setInterview]=useState("");
  const [isLoading,setIsLoading]=useState(false);
  const classes = useStyles();
  const navigate = useNavigate();
  const [hasNextPage, setHasNextPage] = useState({noFilter: true});
  const [isNextPageLoading, setIsNextPageLoading] = useState({noFilter: false});
  const [items, setItems] = useState({noFilter: []});
  const [filter, setFilter] = useState('');
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);
  const {showErrorMessage, hideMessage} = useMessage();
  useEffect(() => {
    setIsLoading(true);
    const payload={
      "mandant": "777",
      "program": "VT01",
      "statement": "DATEN_FUER_SUCHE",
    }
    const headers={
      "Authorization": "Bearer "+props.accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, datenCb, errorCb);
    // eslint-disable-next-line
  }, [])
  
  const errorCb = () => {
    setIsLoading(false);
    showErrorMessage(t("Keine Internetverbindung. Bitte erneut versuchen"));
}
  const datenCb = (response) => {
    console.log(response.data);
    setIsLoading(false);
    if (response.status === 200) {
    } else {
        if (response) {
          console.log(response.data.message);
        } else {
          console.log('Keine Internetverbindung');
        }
    }      
  }  
  
  const onFilterChange = (filterValue) => {
    if (filterValue !== '') {
      const tempItems = Object.assign(items);
      const tempHasNextPage = Object.assign(hasNextPage);
      const tempIsNextPageLoading = Object.assign(isNextPageLoading);
      if (!tempItems[filterValue]) {
        tempHasNextPage[filterValue] = true;
        if (filterValue.length>1) {
          console.log(filterValue.substring(0, filterValue.length-1), tempItems[filterValue.substring(0, filterValue.length-1)].length)
// tempItems[filterValue.substring(0, filterValue.length-1)].length === 0 && 
          if (tempHasNextPage[filterValue.substring(0, filterValue.length-1)] === false) {
            tempHasNextPage[filterValue] = false;
          }
          tempItems[filterValue] = tempItems[filterValue.substring(0, filterValue.length-1)].filter((obj) => obj.name.toLowerCase().includes(filterValue.toLowerCase()));
        } else {
          tempItems[filterValue] = tempItems['noFilter'].filter((obj) => obj.name.toLowerCase().includes(filterValue.toLowerCase()));
        }
      }
      tempIsNextPageLoading[filterValue] = false;
      setItems(tempItems);
      setHasNextPage(tempHasNextPage);
      setIsNextPageLoading(tempIsNextPageLoading);
    }
    setFilter(filterValue);
  }
  const _loadNextPage = (...args) => {
    console.log("loadNextPage", ...args);
    const payload={
      "mandant": props.client, // this.props.client,
      "program": "INOBRW",
      "statement": "SCROLL",
      "filter": filter,
      "von": filter === '' ? items['noFilter'].length+1 : items[filter].length+1,
      "anzahl": 10
    }
    const headers={
      "Authorization": "Bearer "+props.accessToken,
    }
//    apiRequest('POST', 'daten', payload, headers, pageCb);
  };
  const pageCb = (response) => {
    if (response.status === 200) {
        const tempItems = Object.assign(items);
        const tempHasNextPage = Object.assign(hasNextPage);
        const tempIsNextPageLoading = Object.assign(isNextPageLoading);
        if (filter === '') {
          if (response.data.items) {
            tempItems['noFilter'] = tempItems['noFilter'].concat(response.data.items);
          }
          tempHasNextPage['noFilter'] = response.data.hasNextPage==='true';
          tempIsNextPageLoading['noFilter'] = false;
        } else {
          if (response.data.items) {
          tempItems[response.data.filter] = tempItems[response.data.filter].concat(response.data.items);
          }
          tempHasNextPage[response.data.filter] = response.data.hasNextPage==='true';
          tempIsNextPageLoading[response.data.filter] = false;
        }
      setItems(tempItems);
      setHasNextPage(tempHasNextPage);
      setIsNextPageLoading(tempIsNextPageLoading);
      forceUpdate();  
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message)
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
      //navigate(-1);
    }
  }
  return(
    <div className={classes.root}>
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={10} md={8}>
          <Paper>
            <Box p={2}>
              <SearchTextField label={t("Suche")} value={filter} fullWidth variant="outlined" onChange={(e) => onFilterChange(e.target.value)}/>
            </Box>
            <ExampleWrapper
              hasNextPage={filter === '' ? hasNextPage['noFilter'] : hasNextPage[filter]}
              isNextPageLoading={filter === '' ? isNextPageLoading['noFilter'] : isNextPageLoading[filter]}
              items={filter === '' ? items['noFilter'] : items[filter]}
              loadNextPage={_loadNextPage}
            />
          </Paper>
        </Grid>
      </Grid>
      <Grid>
        <TextField label={t("Interview")} onChange={(event)=>setInterview(event.target.value)}></TextField>
      </Grid>
      <Grid>
        <Button  onClick={()=> navigate("/interview/"+interview,
              {state: { programm: "INOBRW" }
            })
            }
            >Interview Starten</Button>
      </Grid>
    </div>
  );
}
export default TestComponent;
